import { useAppDispatch, useAppSelector, useIframe } from '@common/hooks'
import { getUuidFromAppSlug } from '@common/utils/uuid'
import { ErrorContext } from '@layouts/CommonLayout'
import { fetchApplicationInfo, unmountApplicationInfo } from '@redux/slices/application/application'
import { fetchUserSlots } from '@redux/slices/userSlots/userSlots'
import { useRouter } from 'next/router'
import { useContext, useEffect, useState } from 'react'

import type { IProps } from './Application'
import ApplicationLoader from './widgets/ApplicationLoader'


export default function ApplicationNoSsrHOC(Component: ({ autoclose }: IProps) => JSX.Element): (props: Record<string, any>) => JSX.Element {
  let appWasRequested = false
  const WithEmptyApp = (props: Record<string, any>) => {
    const router = useRouter()
    const id = router.query.appId as string
    const dispatch = useAppDispatch()
    const application = useAppSelector(store => store.application.data) as IApplication
    const autoUpdate = useAppSelector(store => store.application.autoUpdate)
    const applicationError = useAppSelector(store => store.application.errors) as { message: string }
    const [firstRenderApp] = useState(application)
    const { setModalError } = useContext(ErrorContext)
    const token = useAppSelector(store => store.common.data?.config?.token)

    useIframe({
      onDashboardHasUpdate: () => {
        if(!autoUpdate) { return }
        const uuid = getUuidFromAppSlug(id)
        if(uuid) {
          void dispatch(fetchApplicationInfo(getUuidFromAppSlug(id) as string))
        }
        void dispatch(fetchUserSlots())
      },
    })

    useEffect(() => {
      if(id && !application && token && !appWasRequested) {
        appWasRequested = true
        const uuid = getUuidFromAppSlug(id)
        if(uuid) {
          void dispatch(fetchApplicationInfo(getUuidFromAppSlug(id) as string))
        }
      }
    }, [token, application])

    useEffect(() => {
      if(applicationError) {
        setModalError(applicationError)
      }
    }, [applicationError])

    useEffect(() => {
      return () => {
        appWasRequested = false
        dispatch(unmountApplicationInfo())
      }
    }, [])

    return (!firstRenderApp || !application)
      ? application
        ? <Component autoclose={props.autoclose as string} />
        : <ApplicationLoader />
      : <Component autoclose={props.autoclose as string} />
  }
  return WithEmptyApp
}
